import {Component, Input, OnInit} from '@angular/core';
import {RankingService} from "../../services/ranking.service";
import {OverlayService} from "../../overlay/overlay.service";
import {RankingListItem} from "../../interfaces/ranking-list-item";
import {DashboardBoxesHeadData} from "../../interfaces/dashboard-boxes-head-data";


@Component({
  selector: 'brt-ranking-list-block',
  templateUrl: './ranking-list-block.component.html',
  styleUrls: ['./ranking-list-block.component.scss']
})
export class RankingListBlockComponent implements OnInit {

  currentPlace = -1;
  totalOrganizations = -1;
  ranking: RankingListItem[] = [];

  headlineBoxData: Partial<DashboardBoxesHeadData> = {
    titleIcon: "raking",
    title: "Rangliste",
    hint: "",
    color: "cyan",
    addHintPulseCircle: true,
    tooltip: "Die Rangliste wird täglich in der Nacht aktualisiert."
  }

  schoolClassId = -1;

  @Input('school-class-id') set setSchoolClassId(id: number) {
    this.schoolClassId = id;
    this.loadData();
  };

  constructor(private rankingService: RankingService, private overlay: OverlayService) {
  }

  async ngOnInit() {

  }

  async loadData() {
    if(this.schoolClassId !== -1) {
      //console.log(this.schoolClassId);
      const excerpt = await this.rankingService.getRankingExcerpt(this.schoolClassId);
      this.totalOrganizations = excerpt.totalOrganizations;
      this.ranking = excerpt.ranking.sort((a, b) => {
        return a.position > b.position ? 1 : -1;
      });

      const myOrganization = this.ranking.filter((item) => item.schoolClassData.id === this.schoolClassId);
      if(myOrganization.length) {
        this.currentPlace = myOrganization[0].position;
      }

      let hintText = "Klasse noch nicht gelistet";
      if(this.currentPlace !== -1){
          hintText = `Platz ${this.currentPlace} von ${this.totalOrganizations}`
      } else {
        this.ranking = this.ranking.slice(0, 7);
      }


      this.headlineBoxData = {
        ...this.headlineBoxData,
        hint: hintText
      };
    } else {
      const ranking = await this.rankingService.getFullRanking();

      this.totalOrganizations = ranking.totalOrganizations;
      this.ranking = ranking.ranking.sort((a, b) => {
        return a.position > b.position ? 1 : -1;
      });

      this.ranking = this.ranking.slice(0, 7);
      this.currentPlace = -1;


      this.headlineBoxData = {
        ...this.headlineBoxData
      };
    }
  }

  openFullList(): void {

    this.rankingService.openRankingOverlay();

  }
}
